import React from "react";
import PropTypes from "prop-types";
import Carousel from "./Carousel";
import Columns from "./Columns";
import Divider from "./Divider";
import Form from "./Form";
import Gallery from "./Gallery";
//import Games from "./Games"
import Hero from "./Hero";
import Intro from "./Intro";
import Jobs from "./Jobs";
import Logos from "./Logos";
//import Media from "./Media"
//import News from "./News"
//import People from "./People"
//import Presskits from "./Presskits"
import Richtext from "./Richtext";
import Spotlight from "./Spotlight";
import Testimonials from "./Testimonials";
import Text from "./Text";

/********************************
<Sections />
/********************************
Version: 2
Created: 11 08 2023
Updated: 23 01 2025
Author: Richy Pears
/********************************
A fundimental component which takes
an object of sections, loops through
and spits them out on the page.

TODO: See if we can make it so
these sections can be clicked on in
the Storyblok editor to help with
navigation to the section
/********************************/

export const Components = {
  carousel: Carousel,
  columns: Columns,
  divider: Divider,
  form: Form,
  gallery: Gallery,
  //  games: Games,
  hero: Hero,
  intro: Intro,
  jobs: Jobs,
  logos: Logos,
  //  media: Media,
  //  news: News,
  //  people: People,
  //  presskits: Presskits,
  richtext: Richtext,
  spotlight: Spotlight,
  testimonials: Testimonials,
  text: Text,
};

const Sections = ({ body, location }) => {
  function oddEven(x) {
    return x & 1 ? "odd" : "even";
  }

  if (!body || body.length === 0) return null; // Escape hatch

  return (
    <>
      {body &&
        body.map((node, index) => {
          //          return <div className="border">Section</div>;

          if (typeof Components[node.component] !== "undefined") {
            const Component = Components[node.component];
            return (
              <Component
                doc={node}
                blok={node}
                key={node._uid}
                location={location}
                oddEven={oddEven(index)}
              />
            );
          }
          return null;
        })}
    </>
  );
};

export default Sections;

Sections.defaultProps = {
  body: null,
  location: null,
};

Sections.propTypes = {
  body: PropTypes.object,
  location: PropTypes.object,
};
